if (typeof jQuery === "function") {
    // @ts-ignore
    define('jquery', [], function () {
        return jQuery;
    });
}
// IE CustomEvent Polyfill
// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
(function () {
    if (typeof window.CustomEvent === "function")
        return false;
    function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }
    CustomEvent.prototype = window.Event.prototype;
    window.CustomEvent = CustomEvent;
    return;
})();
// @ts-ignore
define('@iiif/manifold', ['require', '../lib/manifold.js', 'manifold'], function (require, m) {
    var manifold = require('manifold');
    // @ts-ignore
    window.Manifold = manifold;
    return manifold;
});
// @ts-ignore
define('manifesto.js', ['require', './lib/manifesto.js', 'manifesto'], function (require, m) {
    var manifesto = require('manifesto');
    // @ts-ignore
    window.Manifesto = manifesto;
    // @ts-ignore
    window.manifesto = manifesto;
    return manifesto;
});
// @ts-ignore
define('@iiif/vocabulary', ['require', '../lib/vocabulary.js', 'vocabulary'], function (require, m) {
    return require('vocabulary');
});
// @ts-ignore
define('@iiif/iiif-metadata-component', ['require', '../lib/IIIFMetadataComponent.js', 'IIIFMetadataComponent'], function (require, m) {
    return require('IIIFMetadataComponent');
});
// @ts-ignore
define('@iiif/iiif-gallery-component', ['require', '../lib/GalleryComponent.js'], function (require, m) {
    return m;
});
// @ts-ignore
define('@iiif/iiif-av-component', ['require', '../lib/IIIFAVComponent.js', 'IIIFAVComponent'], function (require, m) {
    return require('IIIFAVComponent');
});
// bundled into dist/uv.js
// - things in src/lib that are generic to all extensions
// - bundled data providers
// - UVComponent
// @ts-ignore
requirejs([
    './lib/base64.min.js',
    './lib/browserdetect.js',
    './lib/detectmobilebrowser.js',
    './lib/jquery.xdomainrequest.js',
    './lib/modernizr.js',
    './lib/ex.es3.min.js',
    './lib/BaseComponent.js',
    './lib/KeyCodes.js',
    './lib/HTTPStatusCode.js',
    './lib/jquery-plugins.js',
    './lib/ba-tiny-pubsub.js',
    'manifesto.js',
    '@iiif/manifold',
    './lib/Utils.js',
    './lib/xss.min.js',
    './lib/fetch.umd.js',
    'URLDataProvider',
    'UVComponent',
    // Extra dependencies.
    '@iiif/iiif-metadata-component',
    '@iiif/iiif-gallery-component',
    '@iiif/vocabulary',
    '@iiif/iiif-av-component'
], function (base64, browserdetect, detectmobilebrowser, xdomainrequest, modernizr, sanitize, exjs, basecomponent, keycodes, httpstatuscodes, jqueryplugins, pubsub, manifesto, manifold, utils, fetch, URLDataProvider, UVComponent) {
    window.UV = UVComponent.default;
    window.UV.URLDataProvider = URLDataProvider.default;
    window.dispatchEvent(new CustomEvent('uvLoaded', {}));
});
//# sourceMappingURL=app.js.map
define("app", function(){});

